import styled from "@emotion/styled";
import { Table } from "@mui/material";

export const StyledTable = styled(Table)(() => ({
  background: "#ffffff",
  boxShadow: "5px 10px 10px #ECECEC",
  borderRadius: "10px",
}));
